// Shared content shape for legal documents (privacy, terms).
//
// One data module is rendered two ways:
//   - the React route renders a Mantine view of it
//   - the build-time generator emits public/<name>.html for crawlers
//
// Inline formatting is expressed as typed runs (text / strong / em / link)
// rather than HTML strings. This keeps both renderers free of
// dangerouslySetInnerHTML — no XSS surface to audit, and the pattern can't
// propagate into code that one day renders user input.
// Authoring helpers — keep the content modules readable.
export const t = (text) => ({ kind: "text", text });
export const s = (text) => ({ kind: "strong", text });
export const em = (text) => ({ kind: "em", text });
export const a = (text, href, external = false) => ({
    kind: "link",
    text,
    href,
    ...(external && { external: true }),
});
// Common block shorthands.
/** Plain-text paragraph. */
export const p = (text) => ({ kind: "p", runs: [t(text)] });
/** Paragraph that starts with a "<strong>Label:</strong> body" pattern. */
export const labelP = (label, body) => ({
    kind: "p",
    runs: [s(`${label}:`), t(` ${body}`)],
});
/** Paragraph composed of arbitrary inline runs. */
export const richP = (...runs) => ({ kind: "p", runs });
/** Bulleted list of plain-text items. */
export const list = (...items) => ({
    kind: "list",
    items: items.map((item) => [t(item)]),
});
/** Bulleted list where each item starts with a "<strong>Label:</strong> body" pattern. */
export const labelList = (...entries) => ({
    kind: "list",
    items: entries.map(([label, body]) => [s(`${label}:`), t(` ${body}`)]),
});
/** Bulleted list with full control over inline runs per item. */
export const richList = (...items) => ({ kind: "list", items });
export const subheading = (text) => ({ kind: "subheading", text });
